import { ClientValue } from "./client-type";
import { FeeEarner, FeeEarnerLevel } from "./fee-earner";
import { Matter, OrganisationalUnit } from "./matter-type";

export enum ExternalMatterTaxStatus {
  NoData = "NoData",
  NotExempt = "NotExempt",
  Exempt = "Exempt",
}

export declare type ExternalMatter = {
  id: number;
  title: string;
  externalReference: string | null;
  organisationalUnit: OrganisationalUnit;
  status: ExternalMatterStatus;
  leadFeeEarner: ExternalMatterFeeEarner;
  client: ClientValue | null;
  taxStatus: ExternalMatterTaxStatus;
  matter?: Matter;
  externalCreatedAt: Date;
  currency?: {
    id: number;
    code: string;
    symbol: string;
  };
};

export interface ExternalMatterFeeEarner extends Pick<FeeEarner, "id" | "name" | "feeEarnerLevel"> {
  id: number;
  name: string;
  feeEarnerLevel: FeeEarnerLevel;
}

export enum ExternalMatterStatus {
  Assigned = "Assigned",
  Unassigned = "Unassigned",
}
export const ALL_External_MATTER_STATUSES: ExternalMatterStatus[] = [
  ExternalMatterStatus.Assigned,
  ExternalMatterStatus.Unassigned,
];

export type ExternalMatterQueryFilter = {
  filter: {
    status: ExternalMatterStatus[];
    client: number[];
  };
};
export type ExternalMatterLazyQueryInput = {
  clientId: number | null;
  statuses: ExternalMatterStatus[];
  search?: string;
  leadFeeEarnerId?: number;
  limit?: number;
  offset?: number;
};
export type ExternalMatterData = {
  data: {
    items: ExternalMatter[];
    total: number;
  };
  get: (input: ExternalMatterLazyQueryInput) => void;
  refetch: (input: ExternalMatterLazyQueryInput) => void;
  called: boolean;
  fetchMore: (input: ExternalMatterLazyQueryInput) => void;
  loading: boolean;
};
